import config from '@config';
import TrackingHelper from './helpers/TrackingHelper';
import LazyLoadingHelper from './helpers/LazyLoadingHelper';
import MarketingHelper from './helpers/MarketingHelper';

console.log('Dope script loaded. App version: ' + config.version);

addEventListener('load', () => {
    console.log('Page fully loaded.');
});

// Setup tracking
// (new TrackingHelper()).setup();

// Setup lazy loading
(new LazyLoadingHelper()).setup();

// Setup marketing
//(new MarketingHelper()).setup();